import { patientMessageTemplateBaseModel } from './crud';

export * from './types';

export const usePatientMessageTemplateById =
  patientMessageTemplateBaseModel.fetchById();
export const usePatientMessageTemplateByIds =
  patientMessageTemplateBaseModel.fetchByIds();
export const usePatientMessageTemplateMany =
  patientMessageTemplateBaseModel.fetchMany();
export const usePatientMessageTemplateFetchPaginated =
  patientMessageTemplateBaseModel.fetchPaginated();
export const usePatientMessageTemplateCount =
  patientMessageTemplateBaseModel.count();
export const usePatientMessageTemplateUpdateOne =
  patientMessageTemplateBaseModel.edit();
export const usePatientMessageTemplateCreateOne =
  patientMessageTemplateBaseModel.create();
export const usePatientMessageTemplateRemoveOne =
  patientMessageTemplateBaseModel.delete();
export const usePatientMessageTemplateRemoveByIds =
  patientMessageTemplateBaseModel.deleteByIds();
